import { apiGet, apiPost } from '../../../apiClient';

export const getBootstrapStatus = () => apiGet('/auth/bootstrap-status');

export const bootstrapSuperuser = (payload) => apiPost('/auth/bootstrap-superuser', payload);
